// Module
var code = "<div class=\"container cs-login-footer\"> <div class=\"row\"> <div class=\"col-sm-12 text-center\"> <a href=\"https://docs.contrastsecurity.com\" target=\"_blank\" translate=\"title_help\"></a> <span class=\"separator\">|</span> <a href=\"https://support.contrastsecurity.com/hc/en-us/requests/new?ticket_form_id=360000011243\" target=\"_blank\" translate=\"title_contactSupport\"></a> </div> </div> </div> ";
// Exports
var _module_exports =code;;
var path = '/views/cs-login-footer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;